import { useEffect, useMemo, useState } from 'react'
import supabase from '../../lib/supabase'
import ClientOperationsEditor from './ClientOperationsEditor'

export default function ClientOperationsPage() {
  const [clients, setClients] = useState([])
  const [selectedId, setSelectedId] = useState('')
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => { load() }, [])

  async function load() {
    try {
      setLoading(true)
      const { data, error: rpcError } = await supabase.rpc('codevaro_clients_360_list')
      if (rpcError) throw rpcError
      setClients(data || [])
      if (!selectedId && data?.length) setSelectedId(data[0].id)
    } catch (err) {
      console.error(err)
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase()
    if (!q) return clients
    return clients.filter((client) => [client.name, client.legal_name, client.phone, client.email, client.vat_number, ...(client.services || [])].filter(Boolean).join(' ').toLowerCase().includes(q))
  }, [clients, search])

  const selected = clients.find((client) => client.id === selectedId)

  if (loading) return <div className="flex h-64 items-center justify-center"><div className="h-12 w-12 animate-spin rounded-full border-b-2 border-blue-600" /></div>

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900">Client Operations</h1>
        <p className="mt-1 text-sm text-slate-600">Edit client establishments, services, partner/accountant links, equipment/networking and ERGANI employees.</p>
      </div>
      {error ? <div className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700">{error}</div> : null}
      <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
        <div className="grid grid-cols-1 gap-3 lg:grid-cols-[1fr_1.4fr]">
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search client, VAT, phone, service..." className="rounded-lg border border-slate-300 px-3 py-2 text-sm" />
          <select value={selectedId} onChange={(e) => setSelectedId(e.target.value)} className="rounded-lg border border-slate-300 px-3 py-2 text-sm">
            <option value="">Select client</option>
            {filtered.map((client) => <option key={client.id} value={client.id}>{client.name}{client.vat_number ? ` · ΑΦΜ ${client.vat_number}` : ''}{client.services?.length ? ` · ${client.services.join(', ')}` : ''}</option>)}
          </select>
        </div>
      </div>
      {selected ? <ClientOperationsEditor client={selected} onChanged={load} /> : <div className="rounded-xl border border-dashed border-slate-300 bg-white p-12 text-center text-sm text-slate-500">Select a client to manage operational data.</div>}
    </div>
  )
}